import {
  ActionCard,
  ActionCardButton,
  ActionCardDescription,
  ActionCardDescriptionContainer,
  ActionCardTitle,
} from "../../OS/Login/ActionCardTitle";
import { Box, AHText, AHTextFonts } from "arkh";
import { CompositeScreenProps } from "@react-navigation/native";
import { FormattedMessage } from "react-intl";

import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { OnboardingNavigatorParamList } from "./navigationParams";
import React from "react";
import { Linking } from "react-native";
import { UserLoggedInNavigatorParamList } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { graphql, useMutation } from "react-relay";

type FinishedSetupScreenProps = CompositeScreenProps<
  NativeStackScreenProps<
    OnboardingNavigatorParamList,
    "OnboardingFinishedSetup"
  >,
  NativeStackScreenProps<UserLoggedInNavigatorParamList>
>;

export const FinishedSetupScreen = ({
  navigation,
}: FinishedSetupScreenProps) => {
  const intl_tokens = useIntlTokens();

  const [notifyOnboardedMutation, isMutating] = useMutation(graphql`
    mutation FinishedSetupScreenMutation {
      me {
        addFlag(flag: FinishedSetup) {
          id
          flags
        }
      }
    }
  `);

  const notifyOnboarded = () => {
    notifyOnboardedMutation({
      variables: {},
      onCompleted: () => {},
    });
  };
  return (
    <Box
      color="background"
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
      }}
      spaceHorizontal="medium"
    >
      <ActionCard>
        <ActionCardTitle>
          <FormattedMessage
            defaultMessage="Great, setup is now done!"
            description="FinishedSetupScreen: title"
          />
        </ActionCardTitle>
        <ActionCardDescriptionContainer>
          <ActionCardDescription>
            <FormattedMessage
              defaultMessage="Good luck with using StoreSprint. You can visit {learn} for a quick walkthrough. Contact us via {contact}."
              description="FinishedSetupScreen: description"
              values={{
                contact: (
                  <AHText
                    color="primary"
                    type="title-small"
                    font={AHTextFonts.REGULAR}
                    style={{ textDecorationLine: "underline" }}
                    onPress={async () => {
                      await Linking.openURL("https://storesprint.com/contact");
                    }}
                  >
                    storesprint.com/contact
                  </AHText>
                ),
                learn: (
                  <AHText
                    color="primary"
                    type="title-small"
                    font={AHTextFonts.REGULAR}
                    style={{ textDecorationLine: "underline" }}
                    onPress={async () => {
                      await Linking.openURL(
                        "https://www.storesprint.com/support"
                      );
                    }}
                  >
                    storesprint.com/support
                  </AHText>
                ),
              }}
            />
          </ActionCardDescription>
        </ActionCardDescriptionContainer>
        <ActionCardButton
          title={intl_tokens.Done}
          loading={isMutating}
          onPress={notifyOnboarded}
        />
      </ActionCard>
    </Box>
  );
};
